// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderBottomOutlinedSvg from "@ant-design/icons-svg/es/asn/BorderBottomOutlined";
import AntdIcon from '../components/AntdIcon';

var BorderBottomOutlined = function BorderBottomOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderBottomOutlinedSvg
  }));
};

BorderBottomOutlined.displayName = 'BorderBottomOutlined';
export default React.forwardRef(BorderBottomOutlined);